// Static data + helpers used by the SignupModal step components.

export const SELF_QUAL_OPTIONS = [
  { id: "hires_5plus",     label: "I've hired employees before — ideally 5 or more on my team today" },
  { id: "margin_10plus",   label: "My business is already at (or near) 10%+ net profit margin" },
  { id: "demand_clear",    label: "My customer base is plentiful and my offering is clearly in demand" },
  { id: "budget_fits",     label: "The consulting fee fits comfortably in my monthly budget" },
  { id: "follows_advice",  label: "I'm willing to follow scaling instructions and apply advice diligently" },
];

// Admin convenience: when Jonathan re-tests the signup flow, the "WAIT" warning
// auto-expires after 2 minutes so he can submit back-to-back test signups without
// manually clearing localStorage.
export const ADMIN_EMAIL = "jonathan@utahbusinessconsultant.com";
export const ADMIN_WAIT_TTL_MS = 2 * 60 * 1000;
